export const placeholderOptions = [
    { id: "PATIENT_PHONE_NUMBER", label: "Patient Phone Number" },
    { id: "PATIENT_ADDRESS", label: "Patient Address" },
    { id: "GP_ADDRESS", label: "GP Address" },
    { id: "GP_PHONE_NUMBER", label: "GP Phone Number" },
] as const;

export const mentionAtomName = "placeholders" as const;
